/// \file setSystemNotifications.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const SetSystemNotificationsList = lazy(() => import('../views/set-system-notifications/list/view'));

async function setSystemNotificationsDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/set-system-notifications/list/loader')).default;
  return actualLoader(args);
}

export async function setSystemNotificationsAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/set-system-notifications/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="setSystemNotifications"
    handle={{
      text: 'Set System Notifications'
      }}
  >
    <Route 
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <SetSystemNotificationsList />
        </Suspense>
      }     
      loader={setSystemNotificationsDataLoader}
      action={setSystemNotificationsAction}
      />
  </Route>
);

export default routes;